import { Sparkles } from 'lucide-react';
import { KbdHint } from '@/components/ui';
import { useUIStore } from '@/stores/uiStore';

export interface TopbarProps {
  title: string;
}

export function Topbar({ title }: TopbarProps) {
  const setCommandPaletteOpen = useUIStore((s) => s.setCommandPaletteOpen);

  return (
    <div className="flex h-14 items-center justify-between gap-4 border-b border-line bg-canvas px-5">
      <h1 className="text-title-lg font-medium tracking-tight text-t1">{title}</h1>
      <button
        type="button"
        onClick={() => setCommandPaletteOpen(true)}
        aria-label="Ask Brainday — open command palette"
        className="flex items-center gap-2 rounded-lg border border-line-2 bg-bg px-3 py-1.5 text-body text-t2 can-hover:hover:bg-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas"
      >
        <Sparkles className="h-3.5 w-3.5" aria-hidden />
        <span>Ask Brainday</span>
        <KbdHint>⌘K</KbdHint>
      </button>
    </div>
  );
}
